<template>
<div class="scoreFound">
    <div class="top">
        <Search class="search" v-model="text" @search="filter"/>
        <Classify class="classify" v-model="typeId" @change="filter"/>
    </div>
    <ScoreContent :scores="pageData.data" @collectChange="collectChange">
        <i class="iconfont icon-all">&nbsp;</i>全部乐谱
    </ScoreContent>
    <div class="pc"><PageController @change="change" v-model="pageData" class="ctl"/></div>
</div>
</template>

<script>
import ScoreContent from '../home/components/scoreContent.vue'
import PageController from './components/pageController.vue'
import Search from './components/search.vue'
import Classify from './components/classify.vue'
import Message from '@/components/library/Message.js'
//import {getAllScores,queryScoreResPage,searchScoreResPage} from '../../api/score'
import {ref} from 'vue'
// import { ScorePower,ScoreStatus } from '../../enum'
// import { scores } from '../../assets/images/score'
import axios from "../../utils/request"
export default {
    name:'ScoreFound',
    components:{
        ScoreContent,
        PageController,
        Classify,
        Search
    },
    setup(){
        let pageSize=8;
        const pageData=ref(null)
        let temp={
            pageNum:1,
            totalNum:1,
            data:[],
            pageSize:pageSize
        }
        pageData.value=temp;
        // pageData.value.data=scores;

        // const getPageScoreList=(pageNum,typeId)=>{
        //     axios.post("/score/getPageScoreList",{
        //         pageSize:8,
        //         pageNum:pageNum,
        //         model:{
        //             power:ScorePower.PUBLIC.value,
        //             status:ScoreStatus.APPROVED.value,
        //             typeId:typeId
        //         }
        //     }).then((data)=>{
        //         pageData.value=data;
        //     }).catch(()=>{
        //         Message({type:"error",text:"网络请求失败，请稍后再试"});
        //     })
        // }
        // getPageScoreList(1,null);

        // const searchPageScoreList=(text,pageNum)=>{
        //     axios.post("/score/searchPageScoreList",{
        //         pageNum:pageNum,
        //         pageSize:8,
        //         model:"%"+text+"%"
        //     }).then((data)=>{
        //         tag.value='search';
        //         pageData.value=data;
        //     }).catch(()=>{
        //         Message({type:"error",text:"网络请求失败，请稍后再试"});
        //     })
        // }

        // const tag=ref('query');
        // const change=()=>{
        //     if(tag.value=='query'){
        //         getPageScoreList(pageData.value.pageNum,null);
        //     }else if(tag.value=='search'){
        //         searchPageScoreList(text.value,1);
        //     }
        // }
        // const text=ref('');
        // const searchScore=()=>{
        //     searchPageScoreList(text.value,1);
        // }
        // const typeId=ref(null);
        // const classify=()=>{
        //     getPageScoreList(1,typeId.value);
        // }

        let user=JSON.parse(localStorage.getItem("user"));
        const text=ref('');
        const typeId=ref(null);
        const getPageScoreList=(pageNum)=>{
            axios.get("/score/getPageScoreListByFilter",{
                params:{
                    searchStr:text.value==""?null:text.value,
                    pageNum:pageNum,
                    pageSize:pageSize,
                    typeId:typeId.value,
                    userId:user==null?null:user.id
                }
            }).then((data)=>{
                pageData.value={
                    data:data.list,
                    pageNum:data.pageNum,
                    totalNum:data.total,
                    pageSize:pageSize
                }
            }).catch(()=>{
                Message({type:"error",text:"网络请求失败，请稍后再试"});
            });
        }

        getPageScoreList(1);

        const change=()=>{
            getPageScoreList(pageData.value.pageNum);
        }

        const filter=()=>{
            getPageScoreList(1);
        }

        const collectChange=(index)=>{
            pageData.value.data[index].collect=!pageData.value.data[index].collect;
        }

        return {pageData,change,text,typeId,filter,collectChange};
    }
}
</script>

<style lang="less" scoped>
.scoreFound{
    margin-top:30px;
    .top{
        margin: auto;
        width: 1200px;
        padding: 30px;
        background-color: white;
        margin-bottom: 10px;
        display: flex;
        .search{
            margin-left: 400px;
        }
        .classify{
            margin-left: 250px;
        }
    }
    .pc{
        margin: auto;
        margin-top: 10px;
        width:1200px;
        padding: 20px;
        background-color: white;
        .ctl{
            margin: auto;
        }
    }
}
i{
    font-size: 30px;
}
</style>
